import "./index.css"

/**
 * Filter console logs - only show warnings and errors
 * Suppresses console.log, console.info, and console.debug
 */
(function() {
    // Store original console methods
    const originalLog = console.log;
    const originalInfo = console.info;
    const originalDebug = console.debug;
    
    // Override console.log to do nothing
    console.log = function() {
        // Suppressed - only warnings and errors are shown
    };
    
    // Override console.info to do nothing
    console.info = function() {
        // Suppressed - only warnings and errors are shown
    };
    
    // Override console.debug to do nothing
    console.debug = function() {
        // Suppressed - only warnings and errors are shown
    };
    
    // Keep console.warn and console.error as-is
    // They will continue to work normally
})();

// Basic JavaScript for the theme
// This log will be suppressed by the filter above
console.log('Tailwind WordPress Boilerplate loaded');